module.exports = __webpack_public_path__ + "assets/img/de-0f4b340f.png";